import { Link } from "react-router";
import { t } from "../i18n/sl";
import { fmtDate } from "../lib/format";
import { useRules } from "../lib/rules";
import { Logo } from "../components/ui";

/** "Aplikacija upošteva predpise, veljavne na dan ..."; the hover text names the rules the date covers. */
export function LegalDate({ date }: { date: string }) {
  return (
    <span className="legal-date" title={t.footer.legalStatusHint}>
      {t.footer.legalStatus(fmtDate(date))}
    </span>
  );
}

/** The honest-scope line that appears on every page.
 *  `privacy`: add the link to /zasebnost ("tab" opens it in a new tab, e.g. mid-survey). */
export function LegalLine({ className, privacy }: { className?: string; privacy?: "same" | "tab" }) {
  const rules = useRules();
  return (
    <p className={`legal-line ${className ?? ""}`}>
      {t.footer.disclaimer} {rules ? <LegalDate date={rules.legal_status_date} /> : null}
      {privacy === "same" && (
        <>
          {" "}
          <Link to="/zasebnost" className="footer-privacy">
            {t.footer.privacyLink}
          </Link>
        </>
      )}
      {privacy === "tab" && (
        <>
          {" "}
          <a href="/zasebnost" target="_blank" rel="noopener" className="footer-privacy">
            {t.footer.privacyLink}
            <span className="sr-only"> {t.common.newTab}</span>
          </a>
        </>
      )}
    </p>
  );
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container site-footer-inner">
        <div className="stack" style={{ ["--gap" as string]: "10px" }}>
          <a href={t.brand.agentcijaUrl} target="_blank" rel="noopener" className="footer-logo">
            <Logo height={22} />
            <span className="sr-only">{t.common.newTab}</span>
          </a>
          <p className="mute small">{t.footer.madeBy}</p>
        </div>
        <div className="stack site-footer-legal" style={{ ["--gap" as string]: "6px" }}>
          <LegalLine />
          <p className="mute small">
            {t.footer.privacy}{" "}
            <Link to="/zasebnost" className="footer-privacy">
              {t.footer.privacyLink}
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
